import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { usePeriscopeMetadata } from '@hooks';
import { MetadataContainer } from '@periscopes/general/metadata';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';
export const PardotListMetadataTab = ({ sonarObjectId }) => {
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.PardotList);
    const metadataEntries = useMemo(() => {
        if (!metadata) {
            return [];
        }
        const entries = [
            {
                label: COPY_SPECIFIC.CRM_VISIBLE,
                type: 'boolean',
                value: metadata.crmVisible
            },
            {
                label: COPY_SPECIFIC.PUBLIC_LIST,
                type: 'boolean',
                value: metadata.publicList
            }
        ];
        return entries;
    }, [metadata]);
    if (loading) {
        return React.createElement(LoadingSpinner, null);
    }
    return React.createElement(MetadataContainer, { entries: metadataEntries, title: COPY_SPECIFIC.LIST_INFORMATION });
};
